module.exports = __webpack_public_path__ + "static/media/ia-initial-icon.2ce99126.png";